/** A select field's option as both adapters hand it over: its code under `name`, beside its label. */
interface SelectOption {
  name?: string;
  label?: string;
}

/**
 * A select field's options in the shape Sparky's `InputSelect` takes: `{ label, value }`, the value being the
 * option's code.
 *
 * Both adapters hand a select field's options over with the code under `name`: Sanity stores it there, and the
 * Sitecore adapter adds it beside Sitecore's own `value`. So every component that fills an `InputSelect` from CMS
 * content reads its options through this, and none maps them by hand. An option without a code is left out,
 * because choosing it could record nothing.
 */
export const selectOptions = (options: readonly SelectOption[] | undefined): Array<{ label: string; value: string }> =>
  (options ?? []).flatMap(option => (option.name ? [{ label: option.label ?? '', value: option.name }] : []));
